var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8534 6.9066V21.9733C27.8534 24.6133 25.7067 26.7599 23.0667 26.7599C20.4401 26.7599 18.2801 24.6133 18.2801 21.9733C18.2801 19.3466 20.4401 17.1999 23.0667 17.1999C24.1867 17.1999 25.1867 17.5866 26.0001 18.2266V10.2933L13.7201 13.7866V24.5466C13.7201 27.1866 11.5601 29.3333 8.9334 29.3333C6.2934 29.3333 4.14673 27.1866 4.14673 24.5466C4.14673 21.9199 6.2934 19.7733 8.9334 19.7733C10.0401 19.7733 11.0401 20.1599 11.8534 20.7866V8.99993C11.8534 7.03993 13.0401 5.51993 14.9201 5.01326L22.6267 2.9066C24.1867 2.47993 25.5067 2.6266 26.4401 3.3466C27.3867 4.05326 27.8534 5.25326 27.8534 6.9066Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicFileIcon);
export default __webpack_public_path__ + "static/media/MusicFileIcon.b4be9b7979fb8f1e308b9f89ede0727d.svg";
export { ForwardRef as ReactComponent };